import { useBotsStore } from "../stores/bots.store";
import { parseISO } from "date-fns";

interface Props {
  lobby: any;
}

const MILLISECONDS_IN_A_DAY = 86400000;

const transformDate = (date: Date) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec"
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear().toString().slice(2);
  return `${month} '${year}`;
};

export const getTimeRemaining = (date: Date) => {
  return (
    Math.floor((date?.getTime() - Date.now()) / MILLISECONDS_IN_A_DAY) + " DAYS"
  );
};

const LobbyInfo: React.FC<Props> = ({ lobby }) => {
  const { startDate, ended, started, challenge, endDate, buyIn } = lobby;

  const parsedStartDate: any = startDate ? parseISO(startDate) : null;
  const winningBot = useBotsStore(state =>
    ended && lobby?.standings?.length
      ? state.bots.find(b => b.id === lobby.standings[0].botId)
      : undefined
  );

  let parsedEndDate: any = endDate ? new Date(endDate) : null;
  if (ended && challenge && winningBot?.backtestConfig?.endTime) {
    parsedEndDate = new Date(winningBot.backtestConfig.endTime);
  }

  const endPeriod = parsedEndDate && transformDate(parsedEndDate);
  const isActive = started && !ended;

  if (!lobby) return null;

  return (
    <>
      <div className="flex items-center bg-primary-80 text-primary-40 ">
        <div className="flex-1 font-bold text-xs py-2 text-center border-r-[0.5px] border-primary-90">
          BUY IN
        </div>
        <div className="flex-1 font-bold text-xs py-2 text-center border-r-[0.5px] border-primary-90">
          TOTAL POT
        </div>
        <div className="flex-1 font-bold text-xs py-2 text-center border-r-[0.5px] border-primary-90">
          # OF BOTS
        </div>
        <div className="flex-1 font-bold text-xs py-2 text-center">
          {lobby?.ended ? "PERIOD" : isActive ? "ENDS IN" : "STARTS IN"}
        </div>
      </div>
      <div className="flex items-center bg-primary-70">
        <div className="flex-1 font-bold text-sm py-2 text-red-400 text-center border-r-[0.5px] border-primary-90">
          {buyIn} QUO
        </div>
        <div className="flex-1 font-bold text-sm py-2 text-green-400 text-center border-r-[0.5px] border-primary-90">
          {lobby?.totalPot} QUO
        </div>
        <div className="flex-1 font-bold text-sm py-2 text-center border-r-[0.5px] border-primary-90">
          {lobby?.bots?.length || 0} BOT{lobby?.bots?.length !== 1 && "S"}
        </div>
        <div className="flex-1 font-bold text-sm py-2 text-center">
          {ended
            ? endPeriod
            : isActive
            ? getTimeRemaining(parsedEndDate)
            : getTimeRemaining(parsedStartDate)}
        </div>
      </div>
    </>
  );
};

export default LobbyInfo;
